import { boot } from 'quasar/wrappers'
import { DefineGlobalPiniaStore } from '@bildvitta/store-adapter'

// active-offers
import activeOffersCampaigns from 'stores/modules/active-offers/campaigns/active-offers-campaigns'
import activeOffersCampaignsPerformance from 'stores/modules/active-offers/campaigns/active-offers-campaigns-performance'
import activeOffersCampaignsDiscardReasons from 'stores/modules/active-offers/campaigns/active-offers-campaigns-discard-reasons'
import activeOffersCampaignsCustomers from 'stores/modules/active-offers/campaigns/active-offers-campaigns-customers'
import activeOffersCampaignsBrokerClassification from 'stores/modules/active-offers/campaigns/active-offers-campaigns-broker-classification'
import activeOffersCampaignsBrokerPerformance from 'stores/modules/active-offers/campaigns/active-offers-campaigns-broker-performance'

import activeOffersCustomers from 'stores/modules/active-offers/customers/active-offers-customers'

import activeOffersAnnualPerformance from 'stores/modules/active-offers/dashboard/active-offers-annual-performance'
import activeOffersBrokerPerformance from 'stores/modules/active-offers/dashboard/active-offers-broker-performance'
import activeOffersBrokerClassification from 'stores/modules/active-offers/dashboard/active-offers-broker-classification'
import activeOffersDiscardReasons from 'stores/modules/active-offers/dashboard/active-offers-discard-reasons'

// credit-processes
import creditProcesses from 'stores/modules/credit-processes/credit-processes'
import creditProcessesSummary from 'stores/modules/credit-processes/credit-processes-summary'
import creditProcessesSimulators from 'stores/modules/credit-processes/credit-processes-simulators'
import creditProcessesDocuments from 'stores/modules/credit-processes/credit-processes-documents'

// dashboard
import dashboardBirthdays from 'stores/modules/dashboard/dashboard-birthdays'
import dashboardBrokersActivities from 'stores/modules/dashboard/dashboard-brokers-activities'
import dashboardBrokersPerformance from 'stores/modules/dashboard/dashboard-brokers-performance'
import dashboardCivilStatus from 'stores/modules/dashboard/dashboard-civil-status'
import dashboardContactGender from 'stores/modules/dashboard/dashboard-contact-gender'
import dashboardContactsIncome from 'stores/modules/dashboard/dashboard-contacts-income'
import dashboardFunnels from 'stores/modules/dashboard/dashboard-funnels'
import dashboardImpactedSalesChannels from 'stores/modules/dashboard/dashboard-impacted-sales-channels'
import dashboardNewContacts from 'stores/modules/dashboard/dashboard-new-contacts'
import dashboardSourceOfContacts from 'stores/modules/dashboard/dashboard-source-of-contacts'

// reports
import reportsCreditProcesses from 'stores/modules/reports/reports-credit-processes'
import reportsCustomers from 'stores/modules/reports/reports-customers'
import reportsProductivity from 'stores/modules/reports/reports-productivity'

// customers
import customers from 'stores/modules/customers/customers'
import customersActions from 'stores/modules/customers/customers-actions'
import customersCreditProcesses from 'stores/modules/customers/customers-credit-processes'
import customersDocuments from 'stores/modules/customers/customers-documents'
import customersFormConfigs from 'stores/modules/customers/customers-form-configs'
import customersGenerateContactMessage from 'stores/modules/customers/customers-generate-contact-message'
import customersHistory from 'stores/modules/customers/customers-history'
import customersMetadata from 'stores/modules/customers/customers-metadata'
import customersSales from 'stores/modules/customers/customers-sales'
import customersImports from 'src/stores/modules/customers/customers-imports'

// others
import activities from 'stores/modules/activities'
import activitiesNotes from 'stores/modules/activities-notes'
import activityTypes from 'stores/modules/activity-types'
import bankingCorrespondents from 'stores/modules/banking-correspondents'
import baseChangeConfigs from 'stores/modules/base-change-configs'
import baseChanges from 'stores/modules/base-changes'
import baseChangesApprovals from 'stores/modules/base-changes-approvals'
import channels from 'src/stores/modules/channels'
import contactLinks from 'stores/modules/contact-links'
import externalCustomers from 'stores/modules/external-customers'
import funnels from 'stores/modules/funnels'
import funnelsManagement from 'stores/modules/funnels-management'
import tags from 'stores/modules/tags'
import roulettesFields from 'stores/modules/roulettes-fields'

// leads receptions
import leadsReceptions from 'stores/modules/leads-receptions/leads-receptions'
import leadsReceptionsWaiting from 'stores/modules/leads-receptions/leads-receptions-waiting'
import leadsReceptionsRoulettes from 'stores/modules/leads-receptions/leads-receptions-roulettes'
import leadsReceptionsDashboard from 'stores/modules/leads-receptions/dashboard'

/**
 * store genérica para ser usada enquanto os componentes QasFormView e QasListView
 * não possuem uma forma de não usar store.
 */
import generics from 'stores/generics/generics'
import leadsReceptionsGenericsFilters from 'stores/generics/leads-receptions-generics-filters'

import { hubStore as hub } from 'hub/pinia'

export default boot(({ app }) => {
  app.use(DefineGlobalPiniaStore, {
    stores: {
      // active-offers
      activeOffersCampaigns,
      activeOffersCampaignsPerformance,
      activeOffersCampaignsDiscardReasons,
      activeOffersCampaignsCustomers,
      activeOffersCampaignsBrokerClassification,
      activeOffersCampaignsBrokerPerformance,
      activeOffersCustomers,
      activeOffersAnnualPerformance,
      activeOffersBrokerPerformance,
      activeOffersBrokerClassification,
      activeOffersDiscardReasons,

      // credit-processes
      creditProcesses,
      creditProcessesSummary,
      creditProcessesSimulators,
      creditProcessesDocuments,

      // dashboard
      dashboardBirthdays,
      dashboardBrokersActivities,
      dashboardBrokersPerformance,
      dashboardCivilStatus,
      dashboardContactGender,
      dashboardContactsIncome,
      dashboardFunnels,
      dashboardImpactedSalesChannels,
      dashboardNewContacts,
      dashboardSourceOfContacts,

      // reports
      reportsCreditProcesses,
      reportsCustomers,
      reportsProductivity,

      // customers
      customers,
      customersActions,
      customersCreditProcesses,
      customersDocuments,
      customersFormConfigs,
      customersGenerateContactMessage,
      customersHistory,
      customersMetadata,
      customersSales,
      customersImports,

      // others
      activities,
      activitiesNotes,
      activityTypes,
      bankingCorrespondents,
      baseChangeConfigs,
      baseChanges,
      baseChangesApprovals,
      channels,
      contactLinks,
      externalCustomers,
      funnels,
      funnelsManagement,
      hub,
      tags,
      roulettesFields,

      // leads receptions
      leadsReceptionsWaiting,
      leadsReceptions,
      leadsReceptionsRoulettes,
      ...leadsReceptionsDashboard,

      // generics
      generics,
      leadsReceptionsGenericsFilters
    }
  })
})
